import { MenuIcon } from '@heroicons/react/solid';
import { useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import ModalFull from '../methods/modal/modalFull/ModalFull';
import ContactPage from '../pages/contact';
import HomePage from '../pages/home';
import SkillPage from '../pages/skill-page';
import WorkPage from '../pages/works';
import Sidebar from '../parts/sidebar/Sidebar';
import AboutPage from '../pages/about/index';
import Gallery from '../pages/galary/Galary';
// import Sidebar from "../parts/sidebar/Sidebar";

export default function Layout({ children }) {
  const [modal, setModal] = useState(false);
  return (
    <div className="layout ">
      {modal && (
        <ModalFull
          onClicked={() => setModal(false)}
          View={() => <Sidebar onClosed={() => setModal(false)} />}
          pos="top"
          width="w-full"
        />
      )}
      <div className="body  sm:container font-semibold">
        <div className="leftPart hidden md:block w-40 fixed h-screen bg-primary-900">
          <Sidebar />
        </div>
        <div
          onClick={() => setModal(!modal)}
          className="block md:hidden fixed right-4 top-4 w-12 h-12 text-primary-50  bg-primary-900 cursor-pointer"
        >
          <MenuIcon className="" />
        </div>
        <div className="rightPart pl-0 md:pl-40 ">
          <div className=" ">{children}</div>
        </div>
      </div>
    </div>
  );
}
